<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  @if (isEditingExistingDashboard) {
    <h2>{{ 'DASHBOARD.EDIT_DASHBOARD' | translate:{name: dashboard.name} }}</h2>
  } @else {
    <h2>{{ 'DASHBOARD.ADD_DASHBOARD' | translate }}</h2>
  }

  <div class="col-xs-12">
    <div [hidden]="submitted">
      <form (ngSubmit)="onSubmit()" #dashboardForm="ngForm">
        <button type="submit" class="btn btn-primary" style="float: right;"
          [disabled]="!dashboardForm.form.valid">Save
        </button>
        <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">Cancel
        </button>

        <br/>
        <br/><br/>
        <div class="form-group">
          <label for="name">{{ 'DASHBOARD.NAME' | translate }}</label>
          <input type="text" class="form-control" id="name" [(ngModel)]="dashboard.name" name="name"
            #name="ngModel" required>
            <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
              {{ 'DASHBOARD.NAME_REQUIRED' | translate }}
            </div>
          </div>

          <div class="form-group">
            <label for="type">{{ 'DASHBOARD.TYPE' | translate }}</label>
            <select [(ngModel)]="dashboard.type" id="type" class="form-control" name="type" #type="ngModel"
              required (change)="onChange($event.target.value);">
              @for (value of dashboardTypes; track value) {
                <option value={{value.key}}>
                  {{ value.name }}
                </option>
              }
            </select>
            <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
              {{ 'DASHBOARD.TYPE_REQUIRED' | translate }}
            </div>
          </div>

          <div class="form-group">
            <label for="sortingOrder">{{'DASHBOARD.SORTING_ORDER' | translate}}</label>
            <input type="number" [step]="1" class="form-control" id="sortingOrder" min="0" max="100"
              [(ngModel)]="dashboard['sortingOrder']" name="sortingOrder" #sortingOrder="ngModel"
              pattern="[0-9]*" onkeydown="return event.key!=='.' && event.key!==','"
              >
              <!--                    <div [hidden]="sortingOrder.valid || sortingOrder.pristine" class="alert alert-danger">-->
              <!--                        {{'DASHBOARD.NAME_REQUIRED' | translate}}-->
            <!--                    </div>-->
          </div>

          <div class="form-group">
            <label for="name">{{ 'DASHBOARD.FOOTER' | translate }}</label>
            <input type="text" class="form-control" id="footer" [(ngModel)]="dashboard.footer" name="footer"
              #footer="ngModel">
            </div>

            <div class="form-group">
              <label for="name">{{ 'DASHBOARD.DESCRIPTION' | translate }}</label>
              <textarea class="form-control rounded-0" id="description" [(ngModel)]="dashboard.description"
              name="description" #description="ngModel" rows="3"></textarea>
            </div>

            <div class="form-check form-switch mt-3">
              <input class="form-check-input" type="checkbox" id="dashIsForPortal"
                [(ngModel)]="dashboard.isForPortal" name="isForPortal">
              <label class="form-check-label" for="dashIsForPortal">{{'PORTAL.DASHBOARD_PUBLISH' | translate}}</label>
            </div>

            <div class="form-group mt-2">
              <label for="portalGroupKey">{{'PORTAL.DASHBOARD_GROUP' | translate}}</label>
              <select class="form-control" id="portalGroupKey"
                [(ngModel)]="dashboard.portalGroupKey" name="portalGroupKey">
                <option value="">{{'PORTAL.GROUP_NONE' | translate}}</option>
                @for (group of portalGroups; track group.key) {
                  <option [value]="group.key">{{group.label}}</option>
                }
              </select>
            </div>

            <div class="input-group">

              <div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="periodSelect"
                    [(ngModel)]="dashboard.periodFilter" name="periodly" #periodly="ngModel"
                    (change)="setDateFilter($event,'period');">
                    <label class="form-check-label" for="periodly">
                      {{ 'DASHBOARD.PERIOD' | translate }}
                    </label>
                  </div>
                  <select [(ngModel)]="dashboard.datePeriod" id="value" class="form-control" name="period"
                    [disabled]="!dashboard.periodFilter" #period="ngModel">
                    @for (value of datePeriods; track value) {
                      <option value={{value.key}}>
                        {{ value.name }}
                      </option>
                    }
                  </select>
                </div>

                <span class="input-group-addon">&nbsp;</span>

                <div style="width: 20%;">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="rangeSelect"
                      [(ngModel)]="dashboard.rangeFilter" name="rangely" #rangely="ngModel"
                      (change)="setDateFilter($event,'range');">
                      <label class="form-check-label" for="rangely">
                        {{ 'DASHBOARD.RANGE' | translate }}
                      </label>
                    </div>
                    <input type="text" name="rangeSelector" autocomplete="off" [(ngModel)]="dashboard.dateRange"
                      placeholder="" class="form-control" bsDaterangepicker
                      [disabled]="!dashboard.rangeFilter">
                    </div>
                  </div>


                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="yearly" [(ngModel)]="dashboard.yearly"
                      name="yearly" #yearly="ngModel">
                      <label class="form-check-label" for="yearly">
                        {{ 'DASHBOARD.GROUP_BY_YEARS' | translate }}
                      </label>
                    </div>


                  </form>


                  <div class="row row-eq-height translucent" style="padding:15px;">
                    <div style="width: 14%; margin-right: 1%;">
                      <label for="type">Service</label>
                      <select [(ngModel)]="serviceId" id="service" class="form-control" name="service" #service="ngModel"
                        (change)="onChangeService($event.target.value);">
                        @for (value of services; track value) {
                          <option value={{value.id}}>
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                        {{ 'DASHBOARD.TYPE_REQUIRED' | translate }}
                      </div>
                    </div>

                    <div style="width: 14%; margin-right: 1%;">
                      <label for="type">File Format</label>
                      <select [(ngModel)]="fileFormatId" id="fileFormat" class="form-control" name="fileFormat"
                        #fileFormat="ngModel" (change)="onChangeFileFormat($event.target.value);">
                        @for (value of fileFormats; track value) {
                          <option value={{value.id}}>
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                        {{ 'DASHBOARD.TYPE_REQUIRED' | translate }}
                      </div>
                    </div>

                    <div style="width: 14%; margin-right: 1%;">
                      <label for="type"> {{ 'DASHBOARD.VALUE' | translate }}</label>
                      <select [(ngModel)]="valueCol" id="value" class="form-control" name="value" #value="ngModel"
                        required>
                        @for (value of values; track value) {
                          <option value={{value.name}}>
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                        {{ 'DASHBOARD.VALUE_REQUIRED' | translate }}
                      </div>
                    </div>

                    <div style="width: 14%; margin-right: 1%;">
                      <label for="type"> {{ 'DASHBOARD.DATE' | translate }}</label>
                      <select [(ngModel)]="dateCol" id="value" class="form-control" name="date" #date="ngModel" required>
                        @for (value of dates; track value) {
                          <option value={{value.name}}>
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                        {{ 'DASHBOARD.DATE_REQUIRED' | translate }}
                      </div>
                    </div>

                    <div style="width: 14%; margin-right: 1%;">
                      <label for="type"> {{ 'DASHBOARD.GROUP_BY' | translate }}</label>
                      <select [(ngModel)]="groupCol1" id="value" class="form-control" name="groupBy1" #groupBy1="ngModel"
                        required>
                        @for (value of allCols; track value) {
                          <option value={{value.name}}>
                            {{ value.name }}
                          </option>
                        }
                      </select>
                      <input type="text" class="form-control" style="margin-top: 4px;" [(ngModel)]="groupCol1Val"
                        name="group1Val" #group1Val="ngModel">
                        <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                          {{ 'DASHBOARD.GROUPING_REQUIRED' | translate }}
                        </div>
                      </div>

                      <div style="width: 14%; margin-right: 1%;">
                        <label for="type">{{ 'DASHBOARD.GROUP_BY' | translate }}</label>
                        <select [(ngModel)]="groupCol2" id="value" class="form-control" name="groupBy2" #groupBy2="ngModel"
                          required>
                          @for (value of allCols; track value) {
                            <option value={{value.name}}>
                              {{ value.name }}
                            </option>
                          }
                        </select>
                        <input type="text" class="form-control" style="margin-top: 4px;" [(ngModel)]="groupCol2Val"
                          name="group2Val" #group2Val="ngModel">
                          <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                            {{ 'DASHBOARD.GROUPING_REQUIRED' | translate }}
                          </div>
                        </div>

                        <div style="width: 4%; margin-right: 1%; position: relative;">
                          <button class="btn btn-primary" (click)="addConfig()" style="position: absolute; left:0;bottom:0;">
                            Add
                          </button>
                        </div>


                      </div>


                      @if (dashboard.dashboardConfigs.length>0) {
                        <div>
                          <table class="table table-striped">
                            <thead>
                              <th scope="col"></th>
                              <th scope="col">{{ 'DASHBOARD.SERVICE' | translate }}</th>
                              <th scope="col">{{ 'DASHBOARD.FILE_FORMAT' | translate }}</th>
                              <th scope="col"> {{ 'DASHBOARD.VALUE' | translate }}</th>
                              <th scope="col">{{ 'DASHBOARD.DATE' | translate }}</th>
                              <th scope="col">{{ 'DASHBOARD.GRP1' | translate }}</th>
                              <th scope="col">{{ 'DASHBOARD.GRP2' | translate }}</th>
                            </thead>
                            <tbody>
                              @for (dConfs of dashboard.dashboardConfigs; track dConfs; let i = $index) {
                                <tr>
                                  <td>
                                    <div style="width: 8%; float: left;  margin-right: 1%;">
                                      <button class="btn btn-primary"
                                        (click)="removeDashboardConfig(i)">{{ 'DASHBOARD.REMOVE' | translate }}
                                      </button>
                                    </div>
                                  </td>
                                  <td>
                                    {{ dConfs.service }}
                                  </td>
                                  <td>
                                    {{ dConfs.fileFormat }}
                                  </td>
                                  <td>
                                    {{ dConfs.valueCol }}
                                  </td>
                                  <td>
                                    {{ dConfs.dateCol }}
                                  </td>
                                  <td>
                                    {{ dConfs.groupCol1 }} @if (dConfs.groupCol1Val) {
                                    <span> ({{ dConfs.groupCol1Val }}
                                    ) </span>
                                  }
                                </td>
                                <td>
                                  {{ dConfs.groupCol2 }} @if (dConfs.groupCol2Val) {
                                  <span> ({{ dConfs.groupCol2Val }}
                                  ) </span>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }


                  <!--<ng-template [service]="service" service-type-form-fields></ng-template>-->


                  <!-- <ntr-service-csv [dashboard]="dashboard" *ngIf="service.type==1"></ntr-service-csv>
                  <ntr-service-mcas [sedashboardrvice]="service" *ngIf="service.type==2"></ntr-service-mcas>
                  <ntr-service-otp [dashboard]="service" *ngIf="service.type==3"></ntr-service-otp> -->


                </div>
              </div>
            </div>

<!--
  Asked on save when the dashboard is being published to the portal but some
  dataset it charts is not. Publishing the dashboard alone is legal (the portal
  serves a dashboard's chart data regardless), so this is a choice, not an error.
-->
<app-modal #publishModal [size]="'medium'">
  <app-modal-header>{{ 'PORTAL.PUBLISH_PROMPT_TITLE' | translate }}</app-modal-header>

  <app-modal-body>
    <p>{{ 'PORTAL.PUBLISH_PROMPT_BODY' | translate }}</p>
    <ul class="list-unstyled mb-3">
      @for (src of unpublishedSources; track src.serviceId + '::' + src.fileFormatId) {
        <li>
          <span class="badge bg-secondary">{{ src.serviceName }}</span>
          <span class="ms-1">{{ src.fileFormatName }}</span>
        </li>
      }
    </ul>
    @if (publishError) {
      <div class="alert alert-danger py-1 px-2 mb-0">{{ publishError }}</div>
    }
  </app-modal-body>

  <app-modal-footer>
    <div class="d-flex justify-content-end gap-2 flex-wrap">
      <button type="button" class="btn btn-outline-secondary" [disabled]="publishing" (click)="cancelPublish()">
        {{ 'PORTAL.PUBLISH_PROMPT_CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-outline-primary" [disabled]="publishing" (click)="publishDashboardOnly()">
        {{ 'PORTAL.PUBLISH_PROMPT_DASHBOARD_ONLY' | translate }}
      </button>
      <button type="button" class="btn btn-primary" [disabled]="publishing" (click)="publishAllThenSave()">
        {{ 'PORTAL.PUBLISH_PROMPT_ALL' | translate }}
      </button>
    </div>
  </app-modal-footer>
</app-modal>
